var fn_overflow = function () {

    var elem_active_overflow = $('.searchsite__wrapper');

    elem_active_overflow.on('show.bs.collapse', function () {
        $('body').addClass('overflow');
    });

    elem_active_overflow.on('hidden.bs.collapse', function () {
        $('body').removeClass('overflow');
    });

}